import { useTranslation } from "react-i18next";
import type { AssignableRole } from "@/shared/organizations/access-client";

interface AddOrganizationRoleFieldsetProps {
  readonly options: readonly AssignableRole[];
  readonly value: AssignableRole;
  readonly onChange: (role: AssignableRole) => void;
  readonly disabled: boolean;
}

/** The role radios of the add flow. */
export function AddOrganizationRoleFieldset({
  options,
  value,
  onChange,
  disabled,
}: AddOrganizationRoleFieldsetProps) {
  const { t } = useTranslation();
  return (
    <fieldset className="space-y-2" disabled={disabled}>
      <legend className="text-sm font-medium">{t("organizationAccess.add.roleLabel")}</legend>
      {options.map((option) => (
        <label key={option} className="flex items-start gap-2 text-sm">
          <input
            type="radio"
            name="add-org-role"
            data-testid={`add-org-role-${option}`}
            checked={value === option}
            onChange={() => onChange(option)}
            className="mt-1 h-4 w-4 accent-primary"
          />
          <span>
            <span className="font-medium">{t(`organizationAccess.roles.${option}`)}</span>
            <span className="block text-xs text-muted-foreground">
              {t(`organizationAccess.add.roleHint.${option}`)}
            </span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
